import { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import SingleItemTable from "../SingleItemTable/SingleItemTable";

function SingleItemTabs(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

SingleItemTabs.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({ summary, series }) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          <Tab label="Description" sx={{ color: "white" }} {...a11yProps(0)} />
          <Tab label="Series" sx={{ color: "white" }} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <SingleItemTabs value={value} index={0}>
        <p dangerouslySetInnerHTML={{ __html: summary }}></p>
      </SingleItemTabs>
      <SingleItemTabs value={value} index={1}>
        <SingleItemTable rows={series}></SingleItemTable>
      </SingleItemTabs>
    </Box>
  );
}
